import { useEffect } from 'react';
import type { Editor } from '@tiptap/core';

export function useRichTextEditorAutoFocus(
  editor: Editor | null,
  autoFocus: boolean
) {
  useEffect(() => {
    if (!editor || !autoFocus) {
      return;
    }

    const timeoutId = setTimeout(() => {
      editor.commands.focus('end');
    }, 0);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [autoFocus, editor]);
}
